const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function loginWithGoogleApi(credential) {
    const response = await fetch(`${API_BASE_URL}/api/auth/google`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ credential }),
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data?.message || "No se pudo iniciar sesión con Google");
    }

    return data;
}